import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index";
import GalleryRoutes from './galleryRoutes';
import OrderRoutes from './orderRoutes';


Vue.use(VueRouter)

var routes = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login-page" */ '../views/auth/Login.vue'),
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import(/* webpackChunkName: "login-page" */ '../views/auth/Logout.vue'),
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue'),
    meta: {
      requiresAuth: true
    },
  },
  ...GalleryRoutes,
  ...OrderRoutes,
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next()
      return;
    /*} else {
      store.dispatch('logoutUser');*/
    }
    next('/')
  } else {
    next()
  }
});

/*router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => !record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next("/login");
      return;
    }
    next();
  } else {
    next();
  }
});*/

export default router;